export default __webpack_public_path__ + "static/media/dashboad-icon.98a24a66.svg";